export default __webpack_public_path__ + "media/415b2866a7c2f7769768dff5d571228c2fbed958180a822b9cb751e7432ded7a.svg";